<template>
	<div class="o-container o-container--thin">
		<preloader-view class="o-v-rhythm--small" />
		<img
			class="visually-hidden"
			v-for="(src, index) in cognitoSignOutURIs"
			:key="index"
			:src="src"
		/>
	</div>
</template>

<script>
	import PreloaderView from '../views/PreloaderView.vue';
	export default {
		components: {
			PreloaderView
		},
		data() {
			return {
				cognitoSignOutURIs: CognitoSignOutImageURIs
			}
		},
		mounted() {
			this.$store.dispatch('user/LOGOUT').then(() => {
				this.$router.push({
					name: 'login',
					params: {
						message: {
							type: 'success',
							value: 'You have been logged out of your Football Account.'
						}
					}
				});
			});
		}
	};
</script>
